import {Component, QueryList, ViewChildren} from '@angular/core';
import {IonicPage, NavController} from 'ionic-angular';
import {MonthlyPlanningPage} from "../order-list/monthly-view";
import {QuotaPage} from "../quota/quota";
import {OperationCard} from "../../model/OperationCard";
import {apiconfig} from "../../app/api.config";
import {DateService} from "../../services/DateService";
import {OperationService} from "../../services/OperationService";
import {LocupaChartsServiceProvider} from "../../providers/locupa-charts-service/locupa-charts-service";
import {AuthService} from "../../services/AuthService";
import {KpiService} from "../../services/KpiService";
import {HomeKpi} from "../../model/HomeKpi";
import {FieldTeamActivityReportPage} from "../field-team-activity-report/field-team-activity-report";
import {SlotsPlanningProgressReportPage} from "../slots-planning-progress-report/slots-planning-progress-report";
import {QuotaBudgetPage} from "../quota/quota-budget";

/**
 * Operation Overview is the page where the customer can have an overview of the activity of the currently active operations, including the nb of orders, assignments, and general quota consumption
 */

@IonicPage()
@Component({
  selector: 'page-operatons-overview',
  templateUrl: 'operatons-overview.html',
})
export class OperationsOverviewPage {

  @ViewChildren('knob') knobCharts: QueryList<any>;
  uiloading: boolean = false;
  picturesLoaded: boolean[] = [];
  picturesReady: boolean[] = [];


  public iconsURL: string = apiconfig.LOGA_ICONS;

  private operationHomeCards: OperationCard[] = [];
  private homeKpis: any[] = [];
  private homePictures: string[] = [];

  constructor(public navCtrl: NavController,
              private dateService: DateService,
              private operationService: OperationService,
              private locupaChartsServiceProvider: LocupaChartsServiceProvider,
              private authService: AuthService,
              private kpiService: KpiService) {
  }


  ionViewWillEnter() {

    this.operationHomeCards = [];
    this.homeKpis = [];
    this.homePictures = [];
    this.picturesLoaded = [];
    this.picturesReady = [];

    this.uiloading = true;


    let promise = this.operationService.loadOperationCards();
    promise.then((cards) => {
      if (cards != null && cards !== undefined) {
        if (cards.length > 0) {

          // save into table
          for (let i = 0; i < cards.length; i++) {

            // build token to display picture
            let time: Date = new Date();
            time.setMinutes(time.getMinutes() + (i + 5));
            if (cards[i].logaWorkDayId != null) {
              let animaToken = this.authService.buildAnimaInputFieldTokenWithTime(cards[i].logaWorkDayId, time.getTime());
              this.homePictures[cards[i].id] = cards[i].urlPhoto + "&operation=" + cards[i].id + "&tkn=" + animaToken;
              this.picturesReady[cards[i].id] = true;
              this.picturesLoaded[cards[i].id] = true;
            } else {
              this.homePictures[cards[i].id] = "";
              this.picturesLoaded[cards[i].id] = true;
            }

            // save cards
            this.operationHomeCards.push(cards[i]);
          }


          let kpiLoadingPromises = [];

          // loading kpis for each operation card
          this.operationHomeCards.forEach(o => {
            kpiLoadingPromises.push(
              this.kpiService.loadHomeKpiSheet(o.id)
                .then((response: HomeKpi[]) => {
                  this.homeKpis[o.id] = [];
                  response.forEach(k => {
                    this.homeKpis[o.id].push(k);
                  });
                })
            );
          });

          Promise.all(kpiLoadingPromises).then(() => {
            this.uiloading = false;


            //we want to wait a short while before rendering the graph, to be sure the canvas elements are rendered
            (async () => {
              await this.sleep(1000);
              this.knobCharts.toArray().forEach(
                (item) => {
                  let opIdAndKpiType: string = item.nativeElement.id.split('|');
                  if (opIdAndKpiType.length === 2) {

                    let opId = opIdAndKpiType[0];
                    let kpiId = opIdAndKpiType[1];

                    let homeKpi: HomeKpi = this.homeKpis[opId].find(kpi => kpi.id === kpiId);
                    if (homeKpi != undefined) {
                      this.locupaChartsServiceProvider.buildHomeKpiChart(homeKpi, item);
                    }
                  }
                });
            })();
          })
        }
      }
    });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  uiShowMenuOfCard: number;

  showOrHideMenu(myEvent: any, operationCard: OperationCard) {

    this.uiShowMenuOfCard = operationCard.id;

  }


  openDashboard(card: OperationCard) {
    // TODO : not work SAME-ORIGIN ISSUE
    /*this.navCtrl.push(KpiSheetsPage, {
      cardId: card.id,
      rolDefinitionName: card.rolDefinitionName,
      urlDashboard: card.urlDashboard
    });*/

    let animaToken: string = this.authService.buildAnimaDashboardToken(card.id, card.rolDefinitionName);
    console.log("anima dash url " + animaToken);

    let target = "_system";
    window.open(card.urlDashboard + "&token=" + animaToken, target);
  }

  openMonthlyView(id: number, opName: string) {
    this.navCtrl.push(MonthlyPlanningPage, {operationId: id, operationName: opName});
  }

  openOrderReportView(card: OperationCard) {
    this.navCtrl.push(FieldTeamActivityReportPage, {'operationCard': card});
  }

  openBudgetQuotaView(card: OperationCard) {
    this.navCtrl.push(QuotaBudgetPage, {'operationCard': card});
  }
  openHourQuotaView(card: OperationCard) {
    this.navCtrl.push(QuotaPage, {'operationCard': card});
  }

  openSlotPlanningProgressReportView(card: OperationCard) {
    this.navCtrl.push(SlotsPlanningProgressReportPage, {'operationCard': card});
  }
  openContactView(card: OperationCard) {
    // not work with window.open (in dev ok, not when we release the apk)
    location.href = 'mailto:' + card.emailManager + '?subject=Contact';
  }

  loadedPicture(id: number) {

  }

  computeBackUrl(opCard: OperationCard): any {
    return {
      "background": "url('https://contact-loga2.agence-impact.com/resources/operation/" + opCard.id + "/banner') center no-repeat black",
      "background-size": "cover"
    };
  }


}



// WEBPACK FOOTER //
// ./src/pages/operatons-overview/operatons-overview.ts